export class PlanView {
  /**
   *
   */
  public level_id: number | null;

  /**
   *
   */
  public level_nom: string;

  /**
   *
   */
  public archive: number | null;

  /**
   *
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public additionalInfos: any;

  /**
   *
   */
  public level_position: number;

  /**
   *
   */
  public level_x: number;

  /**
   *
   */
  public level_file: string;

  /**
   *
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public level_type: any;

  /**
   *
   */
  public level_infos: string;

  /**
   *
   */
  public level_zones: string;

  /**
   *
   */
  public level_couches: string;

  /**
   *
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public bim_model_id: any;

  /**
   *
   */
  public bim_model_transform: string;

  /**
   *
   */
  public guid: string;

  /**
   *
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public views_regions: any;
}
